import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductVideoOutlineSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductVideoOutlineSvg = ({
  ...svgProps
}: ProductVideoOutlineSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      d="M15.915 5.863 3.303 2.483a1 1 0 0 0-1.225.708L1.043 7.055a1 1 0 0 0 .707 1.224l9.77 2.618a1 1 0 0 0 1.072-.384l3.323-4.65ZM3.562 1.518a2 2 0 0 0-2.45 1.414L.077 6.796a2 2 0 0 0 1.414 2.45l9.77 2.617a2 2 0 0 0 2.144-.769l3.324-4.65a1 1 0 0 0-.555-1.547L3.562 1.517Z"
      clipRule="evenodd"
    />
    <path
      fill="#121826"
      fillRule="evenodd"
      d="M17.694 7.408a.5.5 0 0 1 .117.698l-2.485 3.475a.5.5 0 0 1-.813-.581l2.484-3.476a.5.5 0 0 1 .697-.116Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M5 11.25v2.25A2.5 2.5 0 0 1 2.5 16H0v-1h2.5A1.5 1.5 0 0 0 4 13.5V11l1 .25Z"
      clipRule="evenodd"
    />
  </SvgWrapper>
);
